import FooterBar from '@/components/navbar/FooterBar';
import PinGuideTextArea from './components/PinGuideTextArea';
import PinIndicator from './components/PinIndicator';
import PinNumberPad from './components/PinNumberPad';
import usePin from './usePin';
import clsx from 'clsx';

const Pin = () => {
  const { pin, isPinCheckFailed, isLockedModalOpen, onClickNumberBtn, OnClickDeleteBtn, onClickAllClearBtn, onClickLockedModalConfirm } = usePin();
  return (
    <div className="page-container">
      <div className="page-content pin-content">
        <div className="pin-header">
          <h2 className="pin-title heading-4 font-bold">{'PIN 비밀번호 입력'}</h2>
        </div>
        <p className="pin-recovery text-sm font-semibold center">{isPinCheckFailed ? '다시 한번 입력해주세요.' : ''}</p>
        <PinIndicator pin={pin} />
        <PinGuideTextArea isPinCheckFailed={isPinCheckFailed} />
        <PinNumberPad
          onClickNumberBtn={onClickNumberBtn}
          OnClickDeleteBtn={OnClickDeleteBtn}
          onClickAllClearBtn={onClickAllClearBtn}
        />
      </div>
      <FooterBar />

      {/* 출금 제한 모달 */}
      <div className={clsx('modal-overlay', !isLockedModalOpen && 'hidden')} id="lockedModal">
        <div className="modal-content modal-small">
          <button type="button" className="modal-close" onClick={onClickLockedModalConfirm}>
            <img src="./images/close-icon.png" alt="닫기" className="close-icon" />
          </button>

          <div className="modal-body">
            <img src="./images/alert-icon.png" alt="경고" className="modal-icon" />
            <p className="modal-message text-base font-semibold">
              출금에 실패했습니다.<br />
              관리자에게 문의해주세요.
            </p>
            <button
              type="button"
              className="modal-button text-lg font-semibold"
              onClick={onClickLockedModalConfirm}
            >
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pin;
